import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasFlags',
})
export class HasFlagsPipe implements PipeTransform {
  transform(flagsL: number, flagsR: number): boolean {
    //console.log("CHECKING FLAGS: ", flagsL, " - ", flagsR, "  ==  ", (flagsL & flagsR))
    return (flagsL & flagsR) != 0;
  }
}
